import React from 'react';

const Map = () => {
  return (
    <div>
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="40" height="40" rx="20" fill="#35E0A1" />
        <path
          d="M20 30C19.7667 30 19.5667 29.9333 19.4 29.8C19.2333 29.6667 19.1083 29.4917 19.025 29.275C18.7083 28.3417 18.3083 27.4667 17.825 26.65C17.3583 25.8333 16.7 24.875 15.85 23.775C15 22.675 14.3083 21.625 13.775 20.625C13.2583 19.625 13 18.4167 13 17C13 15.05 13.675 13.4 15.025 12.05C16.3917 10.6833 18.05 10 20 10C21.95 10 23.6 10.6833 24.95 12.05C26.3167 13.4 27 15.05 27 17C27 18.5167 26.7083 19.7833 26.125 20.8C25.5583 21.8 24.9 22.7917 24.15 23.775C23.25 24.975 22.5667 25.975 22.1 26.775C21.65 27.5583 21.275 28.3917 20.975 29.275C20.8917 29.5083 20.7583 29.6917 20.575 29.825C20.4083 29.9417 20.2167 30 20 30ZM20 19.5C20.7 19.5 21.2917 19.2583 21.775 18.775C22.2583 18.2917 22.5 17.7 22.5 17C22.5 16.3 22.2583 15.7083 21.775 15.225C21.2917 14.7417 20.7 14.5 20 14.5C19.3 14.5 18.7083 14.7417 18.225 15.225C17.7417 15.7083 17.5 16.3 17.5 17C17.5 17.7 17.7417 18.2917 18.225 18.775C18.7083 19.2583 19.3 19.5 20 19.5Z"
          fill="#1D1B20"
        />
      </svg>
    </div>
  );
};

export default Map;
